<!--
 * @Author: ldx
 * @Date: 2022-10-14 09:31:48
 * @LastEditors: ldx
 * @LastEditTime: 2023-03-29 16:44:19
 * @Description:  帮助手册
-->
<template>
  <router-view></router-view>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped></style>
